if ( !customElements.get( 'masonry-layout' ) )
{
    class MasonryLayout extends HTMLElement {
    constructor() {
        super();
    }

    get gridContainer() {
        return this.querySelector('.f-grid') !== null ? this.querySelector('.f-grid') : this;
    }

    get gridItems() {
        return this.querySelectorAll('.f-column');
    }

    get rowGap() {
        const rowGap = window.getComputedStyle(this.gridContainer).getPropertyValue('--f-row-gap');

        return parseFloat(rowGap.replace('rem', '')) * 10;
    }

    get columnNumber() {
        return window.getComputedStyle(this.gridContainer).getPropertyValue('--f-grid-columns') || 1;
    }

    connectedCallback() {
        this.init();
        // const events = ['matchLaptop','unmatchLaptop','matchTablet','unmatchTablet','matchMobile','unmatchMobile'];
        // events.forEach(event => document.addEventListener(event, this.init.bind(this)));
        window.addEventListener('resize', FoxTheme.utils.debounce(this.init.bind(this), 100), false);
    }

    init() {
        if (FoxTheme.config.mqlMobile) {
        this.disable();
        } else {
        this.calculatePositioning();
        }
    }

    disable() {
        Array.from(this.gridItems).forEach((item) => item.style.removeProperty('--offset-top'));
    }

    calculatePositioning() {
        this.disable();
        if (this.columnNumber <= 1) return;
        Array.from(this.gridItems)
        .slice(this.columnNumber)
        .forEach((col, i) => {
            const prevItem = this.gridItems[i].children[0];
            const currentItem = col.children[0];

            const prevItemPos = prevItem.getBoundingClientRect().bottom;
            const currentItemPos = currentItem.getBoundingClientRect().top;

            const offsetTop = prevItemPos - currentItemPos + this.rowGap;

            col.style.setProperty('--offset-top', `${offsetTop}px`);
        });
    }
    }
    customElements.define('masonry-layout', MasonryLayout);
}